import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson zakládá společnost London Rubber Company, která prodává dovážené kondomy a holičské doplňky.',
		},
		{
			year: 1929,
			description: 'Společnost London Rubber Company (LRC) registruje značku Durex.',
		},
		{
			year: '1950s',
			description: 'Padesátá léta - Durex uvádí na trh první lubrikovaný kondom.',
		},
		{
			year: 1953,
			description: 'Durex jako první vyvíjí a používá elektronické testování.',
		},
		{
			year: '1960s',
			description: 'Šedesátá léta - Durex uvádí na trh první anatomicky tvarovaný kondom.',
		},
		{
			year: '1970s',
			description: 'Sedmdesátá léta - Durex jako první značka kondomů na světě propaguje své výrobky v mnoha zemích.',
		},
		{
			year: '1990s',
			description: 'Devadesátá léta - Durex je první značkou kondomů, která si osvojila mezinárodní „záruky kvality” jako svůj standard.',
		},
		{
			year: 1995,
			description: 'Durex uvádí na trh řadu barevných a ochucených kondomů.',
		},
		{
			year: 1996,
			description: 'Durex jako první značka kondomů zakládá vlastní webové stránky. Nyní má 42 různých webových stránek v zemích, kde má zastoupení.',
		},
		{
			year: 1997,
			description: 'Durex uvádí na trh bezlatexové kondomy. Pro tyto kondomy byl použit nový antialergenní materiál: syntetický polyuretan vyvinutý firmou Durex, který je jemnější a pružnější než přírodní kaučukový latex.',
		},
		{
			year: 1998,
			description: 'Durex jako první značka kondomů provádí a zveřejňuje celosvětový průzkum v kategorii sexuálního zdraví.',
		},
		{
			year: 2001,
			description: 'Durex představuje Pleasuremax. To ze značky Durex dělá první značku kondomů na světě, která uvádí na trh kondom, který je současně vroubkovaný a má stimulační výstupky.',
		},
		{
			year: 2003,
			description: 'Durex uvádí na trh řadu lubrikačních gelů Play.',
		},
		{
			year: 2005,
			description: 'Durex Network zveřejňuje zprávu Face of Global Sex, zkoumající aspekty sexuálního chování. Klade si za cíl informovat především akademiky a politiky.',
		},
		{
			year: 2008,
			description: 'K propagaci bezpečného sexu mezi mladými vyzývá Durex lidi mezi 16 a 24 lety k vytvoření originálního plakátu o sexuálním zdraví, jazykem teenagerů.',
		},
		{
			year: 2009,
			description: 'Durex slaví 80. narozeniny!',
		},
		{
			year: 2010,
			description: 'Durex podpořil iniciativu "Condomize!" Populačního Fondu Organizace Spojených Národů na mezinárodní konferenci o AIDS ve Vídni darem 220 000 kondomů.',
		},
		{
			year: 2019,
			description: 'Durex slaví 90. narozeniny!',
		},
	]
}